import { render, staticRenderFns } from "./Pridelovalec.vue?vue&type=template&id=68bc450c&scoped=true&"
import script from "./Pridelovalec.vue?vue&type=script&lang=js&"
export * from "./Pridelovalec.vue?vue&type=script&lang=js&"
import style0 from "./Pridelovalec.vue?vue&type=style&index=0&id=68bc450c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bc450c",
  null
  
)

export default component.exports